import { render, staticRenderFns } from "./MobileFeaturedCard.vue?vue&type=template&id=3f94b27c&"
import script from "./MobileFeaturedCard.vue?vue&type=script&lang=js&"
export * from "./MobileFeaturedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports